import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import { Section, Group, Container } from 'components/core/Page';
import { H2, Paragraph } from 'components/core/Typography';
import { Image } from 'components/core/Image';
import { Link } from 'components/core/Link';

import './cityLandingPages.scss';

export function CityLandingPages({
	headline,
	subheading,
	cities,
	fillOrder,
	className,
	image,
	storageType,
}) {
	return (
		<Section
			className={classnames(
				'section-container city-landing-pages',
				fillOrder,
				className,
			)}
		>
			<Container>
				{!!image && (
					<Image
						src={image}
						titleIcon
						className="featured-cities-icon"
						alt="Featured Cities Icon"
					/>
				)}
				<Group>
					{/* adding this className in the H2 for specific styling on the Homepage */}
					<H2
						size="large"
						className="clps-list-headline"
					>
						{headline}
					</H2>
					{!!subheading && <Paragraph>{subheading}</Paragraph>}
				</Group>
				<ul className="city-list">
					{cities.map(({ url, name }) => (
						<li key={name}>
							<Link href={url}>
								{`${name}${storageType ? ` ${storageType}` : ''}`}
							</Link>
						</li>
					))}
				</ul>
			</Container>
		</Section>
	);
}

CityLandingPages.propTypes = {
	cities: PropTypes.arrayOf(
		PropTypes.shape({
			url: PropTypes.string,
			name: PropTypes.string,
			city: PropTypes.string,
		}),
	),
	headline: PropTypes.string,
	subheading: PropTypes.string,
	storageType: PropTypes.string,
	fillOrder: PropTypes.oneOf(['horizontal', 'vertical']),
	className: PropTypes.string,
	image: PropTypes.string,
	useCards: PropTypes.bool,
};

CityLandingPages.defaultProps = {
	cities: [],
	fillOrder: 'horizontal',
	useCards: false,
};

export default CityLandingPages;
